import { SavedAddressesComponent } from './features/saved-addresses/saved-addresses.component';
import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './core/gaurds/auth.guard';

export const routes: Routes = [
    {
      path: '',
      component: MainLayoutComponent,
      children: [
        {
          path: '',
          redirectTo: 'home',
          pathMatch: 'full'
        },
        {
          path: 'home',
          loadComponent: () =>
            import('./features/home/home.component').then(m => m.HomeComponent)
        },
        {
          path: 'rooms',
          loadComponent: () =>
            import('./features/rooms/rooms.component').then(m => m.RoomsComponent)
        },
        {
          path: 'saved-addresses',
          canActivate:[AuthGuard],
          loadComponent: () =>
            import('./features/saved-addresses/saved-addresses.component').then(s=> s.SavedAddressesComponent)
        },
        {
          path: 'special-gifts',
          loadComponent: () =>
            import('./features/special-gifts/special-gifts.component').then(m => m.SpecialGiftsComponent)
        },
          {path: 'contact-us',
          loadComponent: () =>
            import('./features/contact-us/contact-us.component').then(m => m.ContactUsComponent)
        },
        {
          path: 'profile',
          canActivate:[AuthGuard],
          loadComponent: () =>
            import('./features/profile/profile.component').then(m => m.ProfileComponent)
        },
        {
          path: 'purchase/:id',
          loadComponent: () =>
            import('./features/purchase-selection-panel/purchase-selection-panel.component').then(m => m.PurchaseSelectionPanelComponent)
        },
        {
          path: 'room-details/:id',
          loadComponent: () =>
            import('./features/room-details/room-details.component').then(m => m.RoomDetailsComponent)
        },
        {
          path: 'orders',
          canActivate:[AuthGuard],
          loadComponent: () =>
            import('./features/orders/orders.component').then(m => m.OrdersComponent)
        },
        {
          path: 'super-reward/:id',
          loadComponent: () =>
            import('./features/super-reward/super-reward.component').then(m => m.SuperRewardComponent)
        },
        {
          path: 'order-confirmation-receipt/:id',
          canActivate:[AuthGuard],
          loadComponent: () =>
            import('./features/order-confirmation-receipt/order-confirmation-receipt.component').then(m => m.OrderConfirmationReceiptComponent)
        },
        {
          path: 'PaymentCheckout',
          canActivate:[AuthGuard],
          loadComponent: () =>
            import('./features/payment-checkout/payment-checkout.component').then(m => m.PaymentCheckoutComponent)
        },
         {
          path: 'payment-confirmation',
          canActivate:[AuthGuard],
          loadComponent: () =>
            import('./features/payment-confirmation/payment-confirmation.component').then(m => m.PaymentConfirmationComponent)
        }
      ]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
          {
            path: 'login',
            loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
          },
          {
            path: 'register',
            loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
          },
          {
            path: 'verify',
            loadComponent: () => import('./features/auth/verify/verify.component').then(m => m.VerifyComponent)
          }

        ]
      } ,
      {
        path: '**',
        redirectTo: 'home',
        pathMatch: 'full'
      },
  ];

